export default __webpack_public_path__ + "fd4f7e218c4118e04724f8345de551a7.svg";